<template>
  <b-row align-h="center">
    <b-col md="4" align-self="center">
      <p v-if="itemCount > 0">
        Angebote: {{ (currentPage - 1) * perPage + 1 }} bis {{ lastItem }} von
        {{ itemCount }}<br />
      </p>
    </b-col>
    <b-col md="4" class="text-center" align-self="center">
      <b-pagination
        @change="setCurrentPage"
        :value="currentPage"
        :total-rows="itemCount"
        :per-page="perPage"
        align="center"
      ></b-pagination>
    </b-col>
    <b-col md="4" class="text-md-right" align-self="center">
      <b-form-group
        label="Angebote pro Seite"
        label-for="select-page-size"
        label-cols-md="10"
      >
        <b-form-select
          id="select-page-size"
          @change="setPerPage"
          :options="options"
          :value="perPage"
        ></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  data() {
    return {
      options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
      ],
    }
  },
  computed: {
    ...mapGetters(['itemCount','perPage','currentPage','lastItem']),
  },
  methods: {
    ...mapMutations(['setCurrentPage', 'setPerPage']),
  }
}
</script>

<style>

</style>